export default __webpack_public_path__ + "static/media/virtual-tour-slide-5-tablet.e50b242f.png";